/*整个界面都需要消息通讯imData*/

const initState = {
    currentCameraId: "",
    currentMicrophoneId: "",
    cameras: [],//
    microphones: [],
}
export default {
    namespaced: true,
    state: initState,
    mutations: {
        set_cameras(state, cameras) {
            state.cameras = cameras
        },
        set_microphones(state, microphones) {
            state.microphones = microphones
        },
        set_default_currentCameraId(state,currentCameraId) {
            state.currentCameraId=currentCameraId
        },
        set_default_currentMicrophoneId(state,currentMicrophoneId) {
            state.currentMicrophoneId=currentMicrophoneId
        }
    },
    getters: {},
    actions: {},
}



// WEBPACK FOOTER //
// ./src/match/pages/commonPage/meeting/mettingStore.js